import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import Transparent from '../images/sprite/transparent.gif'
import Cookies from 'universal-cookie';
import { AiFillEyeInvisible, AiFillEye, AiOutlineUser, AiOutlineLock, AiOutlineClose } from 'react-icons/ai'
import { FaWhatsapp, FaTelegram, FaSkype, FaInstagram, FaEnvelope } from 'react-icons/fa'
import { suid } from 'rand-token';
import axios from 'axios';
import FirsttimeLogin from './Mobilefirstlogin'



const cookies = new Cookies();

window.flag = 0;

var cc;
var tt;


export default function Loginmobile(props) {
	const [Socialicon, setSocialicon] = useState(0);
	const [isLoggedIn, setLoggedIn] = useState(false);
	const [isError, setIsError] = useState(false);
	const [userid, setId] = useState("");
	const [password, setPassword] = useState("");
	const [captchaSuccess, setCaptcha] = useState(false);
	const [loading, setloading] = useState(false);
	const [firstlogin, setfirstlogin] = useState(0)
	const [viewpass, setViewpass] = useState(false)







	function createCaptcha() {
		if (document.getElementById('captch')) {
			document.getElementById("captch").remove();
		}

		var captcha = [];
		while (captcha.length < 4) {
			//below code will not allow Repetition of Characters
			var index = Math.floor(Math.random() * 10); //get the next character from the array

			captcha.push(index);

		}
		var canv = document.createElement("canvas");
		canv.style.width = 'inherit';
		canv.id = "captch";
		canv.width = 70;
		canv.height = 50;

		var ctx = canv.getContext("2d");
		ctx.font = "600 30px Arial";
		ctx.fillText(captcha.join(""), 0, 30)
		//ctx.strokeText(captcha.join(""), 0, 30);
		//storing captcha so that can validate you can save it somewhere else according to your specific requirements
		cc = captcha.join("");

		if (document.getElementById("popupcaptcha")) {
			document.getElementById("popupcaptcha").appendChild(canv);
		}
		else {
			document.getElementById("captcha").appendChild(canv);
		}




	}


	function validateCaptcha(event) {
		//event.preventDefault();

		if (event.target.value === cc) {
			setCaptcha(true);

		} else {
			setCaptcha(false);
		}

	}

	useEffect(() => {

		createCaptcha();

	}, []);



	const handleLogin = async () => {


		if (userid === '') {
			createCaptcha();
			const errorElement = document.getElementById("errorMsg");
			errorElement.innerHTML = "Username is empty";
			errorElement.style.display = "block";
			return;
		}
		if (password === '') {
			createCaptcha();
			const errorElement = document.getElementById("errorMsg");
			errorElement.innerHTML = "Password is empty";
			errorElement.style.display = "block";
			return;
		}

		if (!captchaSuccess) {
			createCaptcha();
			const errorElement = document.getElementById("errorMsg");
			errorElement.innerHTML = "Captcha is not valid!";
			errorElement.style.display = "block";
			return;
		}


		var demoid1 = 'demo01';
		//var demoid2 = 'demo02'
		var token = suid(16);
		if (userid.toUpperCase() === demoid1.toUpperCase()) {
			token = '123456789';
		}
		tt = token;


		let userId = userid.toUpperCase()

		cookies.set('id', userId, { path: '/' });
		cookies.set('token', token, { path: '/' });
		cookies.set('password', password, { path: '/' });



		axios.post('https://liveapi247.live/api8/userlogin', {
			id: userId,
			password: password,
			token: token,
			// geoLocation: JSON.stringify(geoLocation)
		})
			.then((result) => {

				if (result.status === 201) {

					setfirstlogin(1);

				}
				else if (result.status === 202) {

					setfirstlogin(2);

				}

				else if (result.status === 200) {

					setLoggedIn(true);
					//props.checkLogin(true);
					setCaptcha(false);

					window.location.href = '/home';

					//window.location.reload();


				}
				else if (result.status === 205) {
					setCaptcha(false);
					const errorElement = document.getElementById("errorMsg");
					errorElement.innerHTML = "User Blocked!";
					errorElement.style.display = "block";
					createCaptcha();
				}
				else {
					setCaptcha(false);
					const errorElement = document.getElementById("errorMsg");
					errorElement.innerHTML = "Username or password incorrect!";
					errorElement.style.display = "block";
					createCaptcha();
				}
			}

			).catch(e => {
				setIsError(true);
			});



	};



	return (
		<React.Fragment>
			<style>{`
				.modern-login-container {
					min-height: 100vh;
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					display: flex;
					flex-direction: column;
					font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
				}
				
				.login-header {
					background: rgba(255, 255, 255, 0.1);
					backdrop-filter: blur(10px);
					padding: 20px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid rgba(255, 255, 255, 0.2);
				}
				
				.login-header h1 {
					color: white;
					font-size: 24px;
					font-weight: 700;
					margin: 0;
					text-shadow: 0 2px 4px rgba(0,0,0,0.3);
				}
				
				.close-btn {
					background: rgba(255, 255, 255, 0.2);
					border: none;
					border-radius: 50%;
					width: 40px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					color: white;
					font-size: 20px;
					cursor: pointer;
					transition: all 0.3s ease;
				}
				
				.close-btn:hover {
					background: rgba(255, 255, 255, 0.3);
					transform: scale(1.1);
				}
				
				.login-form-container {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 40px 20px;
				}
				
				.login-form {
					background: rgba(255, 255, 255, 0.95);
					backdrop-filter: blur(20px);
					border-radius: 20px;
					padding: 40px 30px;
					width: 100%;
					max-width: 400px;
					box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
					border: 1px solid rgba(255, 255, 255, 0.2);
				}
				
				.form-title {
					text-align: center;
					color: #333;
					font-size: 28px;
					font-weight: 700;
					margin-bottom: 30px;
					background: linear-gradient(135deg, #667eea, #764ba2);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
				}
				
				.input-group {
					position: relative;
					margin-bottom: 25px;
				}
				
				.input-icon {
					position: absolute;
					left: 15px;
					top: 50%;
					transform: translateY(-50%);
					color: #667eea;
					font-size: 20px;
					z-index: 2;
				}
				
				.form-input {
					width: 100%;
					padding: 15px 15px 15px 50px;
					border: 2px solid #e1e5e9;
					border-radius: 12px;
					font-size: 16px;
					background: white;
					transition: all 0.3s ease;
					box-sizing: border-box;
				}
				
				.form-input:focus {
					outline: none;
					border-color: #667eea;
					box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
				}
				
				.password-toggle {
					position: absolute;
					right: 15px;
					top: 50%;
					transform: translateY(-50%);
					color: #667eea;
					font-size: 20px;
					cursor: pointer;
					z-index: 2;
					transition: color 0.3s ease;
				}
				
				.password-toggle:hover {
					color: #764ba2;
				}
				
				.captcha-container {
					display: flex;
					gap: 15px;
					align-items: center;
				}
				
				.captcha-input {
					flex: 1;
					padding: 15px;
					border: 2px solid #e1e5e9;
					border-radius: 12px;
					font-size: 16px;
					background: white;
					transition: all 0.3s ease;
				}
				
				.captcha-display {
					background: #f8f9fa;
					border: 2px solid #e1e5e9;
					border-radius: 12px;
					padding: 10px;
					min-width: 80px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				
				.login-btn {
					width: 100%;
					padding: 15px;
					background: linear-gradient(135deg, #667eea, #764ba2);
					color: white;
					border: none;
					border-radius: 12px;
					font-size: 18px;
					font-weight: 600;
					cursor: pointer;
					transition: all 0.3s ease;
					margin-top: 10px;
					text-transform: uppercase;
					letter-spacing: 1px;
				}
				
				.login-btn:hover {
					transform: translateY(-2px);
					box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
				}
				
				.login-btn:active {
					transform: translateY(0);
				}
				
				.error-message {
					color: #e74c3c;
					text-align: center;
					margin-top: 15px;
					font-size: 14px;
					font-weight: 500;
					padding: 10px;
					background: rgba(231, 76, 60, 0.1);
					border-radius: 8px;
					border: 1px solid rgba(231, 76, 60, 0.2);
				}
				
				.policy-links {
					background: rgba(255, 255, 255, 0.1);
					backdrop-filter: blur(10px);
					padding: 20px;
					border-top: 1px solid rgba(255, 255, 255, 0.2);
				}
				
				.policy-grid {
					display: grid;
					grid-template-columns: repeat(2, 1fr);
					gap: 15px;
					list-style: none;
					padding: 0;
					margin: 0;
				}
				
				.policy-link {
					background: rgba(255, 255, 255, 0.2);
					border-radius: 8px;
					padding: 12px;
					text-align: center;
					transition: all 0.3s ease;
				}
				
				.policy-link:hover {
					background: rgba(255, 255, 255, 0.3);
					transform: translateY(-2px);
				}
				
				.policy-link a {
					color: white;
					text-decoration: none;
					font-size: 12px;
					font-weight: 500;
				}
				
				.support-section {
					background: rgba(255, 255, 255, 0.1);
					backdrop-filter: blur(10px);
					padding: 20px;
					border-top: 1px solid rgba(255, 255, 255, 0.2);
				}
				
				.support-title {
					color: white;
					text-align: center;
					margin-bottom: 20px;
					font-size: 18px;
					font-weight: 600;
				}
				
				.support-icons {
					display: flex;
					justify-content: center;
					gap: 20px;
					margin-bottom: 15px;
				}
				
				.support-icon {
					width: 50px;
					height: 50px;
					border-radius: 50%;
					background: rgba(255, 255, 255, 0.2);
					display: flex;
					align-items: center;
					justify-content: center;
					color: white;
					font-size: 24px;
					cursor: pointer;
					transition: all 0.3s ease;
				}
				
				.support-icon:hover {
					background: rgba(255, 255, 255, 0.3);
					transform: scale(1.1);
				}
				
				.support-icon.active {
					background: white;
					color: #667eea;
				}
				
				.support-info {
					text-align: center;
					min-height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				
				.support-detail {
					display: none;
				}
				
				.support-detail.open {
					display: block;
				}
				
				.support-detail a {
					color: white;
					text-decoration: none;
					font-weight: 500;
					padding: 8px 16px;
					background: rgba(255, 255, 255, 0.2);
					border-radius: 20px;
					transition: all 0.3s ease;
				}
				
				.support-detail a:hover {
					background: rgba(255, 255, 255, 0.3);
				}
			`}</style>
			{firstlogin == 0 &&
				<div className="modern-login-container">
					<header className="login-header">
						<h1>betsbuzz365</h1>
						<Link to="/" onClick={() => { props.checkShowLogin(false) }}>
							<button className="close-btn">
								<AiOutlineClose />
							</button>
						</Link>
					</header>
					
					<div className="login-form-container">
						<div className="login-form">
							<h2 className="form-title">Welcome Back</h2>
							
							<div className="input-group">
								<AiOutlineUser className="input-icon" />
								<input 
									className="form-input"
									type="email" 
									value={userid} 
									onChange={(e) => { setId(e.target.value) }} 
									placeholder="Username"
								/>
							</div>
							
							<div className="input-group">
								<AiOutlineLock className="input-icon" />
								<input 
									className="form-input"
									type={viewpass ? "text" : "password"} 
									value={password} 
									onChange={(e) => { setPassword(e.target.value) }}
									placeholder="Password"
								/>
								{viewpass ? (
									<AiFillEye 
										className="password-toggle"
										onClick={() => setViewpass(!viewpass)} 
									/>
								) : (
									<AiFillEyeInvisible 
										className="password-toggle"
										onClick={() => setViewpass(!viewpass)}
									/>
								)}
							</div>
							
							<div className="input-group">
								<div className="captcha-container">
									<input 
										className="captcha-input"
										onChange={(e) => { validateCaptcha(e) }} 
										type="text" 
										inputMode="numeric" 
										maxLength="4" 
										placeholder="Enter Captcha"
									/>
									<div className="captcha-display">
										<div id="popupcaptcha"></div>
									</div>
								</div>
							</div>
							
							<button 
								className="login-btn"
								onClick={handleLogin}
							>
								{loading ? 'Logging in...' : 'Login'}
							</button>
							
							<div id="errorMsg" className="error-message" style={{display: 'none'}}></div>
						</div>
					</div>
					
					<div className="policy-links">
						<ul className="policy-grid">
							<li className="policy-link"><a onClick={() => { props.handlepolicy(4, true) }}>KYC</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(6, true) }}>About Us</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(1, true) }}>Privacy Policy</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(5, true) }}>Responsible Gaming</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(2, true) }}>Terms & Conditions</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(8, true) }}>Underage Gaming</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(7, true) }}>Self-Exclusion</a></li>
							<li className="policy-link"><a onClick={() => { props.handlepolicy(3, true) }}>Rules & Regulations</a></li>
						</ul>
					</div>
					<div className="support-section">
						<h3 className="support-title">Need Help? Contact Support</h3>
						<div className="support-icons">
							<div 
								className={`support-icon ${Socialicon === 0 ? 'active' : ''}`}
								onClick={() => setSocialicon(0)}
							>
								<FaEnvelope />
							</div>
							<div 
								className={`support-icon ${Socialicon === 1 ? 'active' : ''}`}
								onClick={() => setSocialicon(1)}
							>
								<FaWhatsapp />
							</div>
							<div 
								className={`support-icon ${Socialicon === 2 ? 'active' : ''}`}
								onClick={() => setSocialicon(2)}
							>
								<FaTelegram />
							</div>
							<div 
								className={`support-icon ${Socialicon === 3 ? 'active' : ''}`}
								onClick={() => setSocialicon(3)}
							>
								<FaSkype />
							</div>
							<div 
								className={`support-icon ${Socialicon === 4 ? 'active' : ''}`}
								onClick={() => setSocialicon(4)}
							>
								<FaInstagram />
							</div>
						</div>
						<div className="support-info">
							<div className={`support-detail ${Socialicon === 0 ? 'open' : ''}`}>
								{Socialicon === 0 && <a href="mailto:support@betsbuzz365.com">support@betsbuzz365.com</a>}
							</div>
							<div className={`support-detail ${Socialicon === 1 ? 'open' : ''}`}>
								{Socialicon === 1 && <a href="https://wa.me/+970000">+97 0000 0000</a>}
							</div>
							<div className={`support-detail ${Socialicon === 2 ? 'open' : ''}`}>
								{Socialicon === 2 && <a href="https://t.me/betsbuzz365">@betsbuzz365</a>}
							</div>
							<div className={`support-detail ${Socialicon === 3 ? 'open' : ''}`}>
								{Socialicon === 3 && <a href="skype:betsbuzz365">betsbuzz365</a>}
							</div>
							<div className={`support-detail ${Socialicon === 4 ? 'open' : ''}`}>
								{Socialicon === 4 && <a href="https://instagram.com/betsbuzz365">@betsbuzz365</a>}
							</div>
						</div>
					</div>
				</div>
			}
			{(firstlogin == 1 || firstlogin == 2) &&

				<FirsttimeLogin password={password} firstlogin={firstlogin} userid={userid} utoken={tt} />

			}
		</React.Fragment>
	)

}
